export default {"src":"/_next/static/media/revolut.32c6e042.svg","height":50,"width":50};